module.exports = __webpack_public_path__ + "img/GENERAL-IGNIS-2021-1.d7074e3e.jpg";